import { CourseExpiryFilterSubType, ExpiryFilterType } from "../../../services/medicationmanagement/patientApi/models/ExpiryFilterType";
import { RadioButtonGroup } from '../../common/radio-button-group';
import { RenderIf } from "../../common/render-if/RenderIf";
import styles from "./ResidentFilter.module.scss";
export interface IChartExpiryFilterProps{
    expiryType: ExpiryFilterType,
    courseExpiryFilterSubType:CourseExpiryFilterSubType,
    totalNumberOfResults?:number;
    totalChartDueNowAndSoon?: number;
    totalCourseDueNowAndSoon?: number;
    onChange:(val:ExpiryFilterType)=>void;
    onChangeSubFilter:(val:CourseExpiryFilterSubType)=>void;
}


const createOptions =(totalNumberOfResults?:number, totalDueNowAndSoon?:number,totalDueNow?:number)=>{ 
    let totalLabel = totalNumberOfResults?`Show all (${totalNumberOfResults})`:'Show all';
    let totalChartLabel = totalDueNowAndSoon ? `Show charts expiring/expired (${totalDueNowAndSoon})` :'Show charts expiring/expired';
    let totalCourseLabel = totalDueNow ? `Show courses expiring/expired (${totalDueNow})` :'Show courses expiring/expired';

    return [{
        code: ExpiryFilterType.All,
        desc: totalLabel
    },{
        code: ExpiryFilterType.ChartDueNowOrSoon,
        desc: totalChartLabel
    },{
        code: ExpiryFilterType.CourseDueNowOrSoon,
        desc: totalCourseLabel
    }];
};

const createCourseExpirySubOptions =()=>{ 

    return [{
        code: CourseExpiryFilterSubType.CourseExpiryInOneDay,
        desc: "Within 1 day"
    },{
        code: CourseExpiryFilterSubType.CourseExpiryInTwoDays,
        desc: "Within 2 days"
    },{
        code: CourseExpiryFilterSubType.CourseExpiryInThreeDays,
        desc: "Within 3 days"
    },{
        code: CourseExpiryFilterSubType.CourseExpiryInSevenDays,
        desc: "Within 7 days"
    }];
};

export const ChartExpiryFilter=(props:Readonly<IChartExpiryFilterProps>)=>{

    
    let options = createOptions(props.totalNumberOfResults,props.totalChartDueNowAndSoon,props.totalCourseDueNowAndSoon);
    let subOptions = createCourseExpirySubOptions();
    return (
        <div>
            <RadioButtonGroup
            value={props.expiryType} 
            options={options}
            controlLabel="Chart &amp; course expiry"
            nameField="desc"
            valueField="code"
            onChange={props.onChange}
            />

            <RenderIf if={props.expiryType == ExpiryFilterType.CourseDueNowOrSoon}>
                <div className={styles.subFilterRadioGroup}>
                    <RadioButtonGroup
                    value={props.courseExpiryFilterSubType} 
                    options={subOptions}
                    nameField="desc"
                    valueField="code"
                    onChange={props.onChangeSubFilter}
                    />
                </div>
            </RenderIf>
        
        </div>
    );
};